import { render } from "./PistonPage.vue?vue&type=template&id=1490041e"
import script from "./PistonPage.vue?vue&type=script&lang=js"
export * from "./PistonPage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__